import Cookies from "js-cookie";
import { ACCESS_TOKEN } from "../constants/global";
import { getHostedDomain } from "./getHostedDomain";

export const removeAccessToken = (): void =>
  Cookies.remove(ACCESS_TOKEN, { domain: getHostedDomain() });
